module.exports = __webpack_public_path__ + "38932d0927407ea66bc7f3667dafffba.pdf";